import { useQuery } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { fetchData } from 'src/api/api-utilities'

const updateEventId = async (eventId) => {
  const response = await fetchData('/my_evanta/set_event/', { eventId })
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response.data
}

// Always call useQuery, just disable it if eventId is empty
const useUpdateLastEventClicked = (eventId) => {
  const { data, isLoading } = useQuery({
    queryKey: ['event', eventId || 'none'],
    queryFn: () => updateEventId(eventId),
    enabled: !!eventId,
    retry: false
  })
  const event = isEmpty(data) ? {} : data.event
  return {
    currentEvent: event,
    isLoadingEvent: isLoading
  }
}

export default useUpdateLastEventClicked
